<template>
    <div>
        <top></top>
        <div class="container refu_wp">
            <breadcrumb></breadcrumb>
            <div class="my-title">
                申请退款
            </div>
            <div class="step">
                <el-steps :active="active" align-center process-status="wait">
                    <el-step title="退货退款"></el-step>
                    <el-step title="进行中"></el-step>
                    <el-step
                        :title="detail.aftersale_status == -1 ? '拒绝' : '完成'"
                    ></el-step>
                </el-steps>
            </div>
            <div class="refuse" style="display:flex;">
                <div>
                    <el-form ref="form" :model="form" label-width="100px">
                        <el-form-item label="退货商品：">
                            <div class="flex ali-cen">
                                <img
                                    :src="orderDetail.goods_image"
                                    style="width: 100px;height: 100px;margin-right: 20px;"
                                    alt=""
                                />
                                <div class="f18">
                                    <div>{{ orderDetail.goods_title }}</div>
                                    <div class="grey">
                                        {{ orderDetail.goods_sku_text }}
                                    </div>
                                </div>
                            </div>
                        </el-form-item>
                        <template v-if="detail.aftersale_status == 1">
                            <el-form-item label="服务类型：">
                                <el-radio-group
                                    v-model="form.type"
                                    :disabled="active == 2 || active == 3"
                                >
                                    <el-radio
                                        :label="item.value"
                                        :key="index"
                                        v-for="(item, index) in refundTypeList"
                                        >{{ item.title }}</el-radio
                                    >
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="申请原因：">
                                <el-select
                                    :disabled="active == 2 || active == 3"
                                    v-model="form.reason"
                                    placeholder="请选择退款原因"
                                >
                                    <el-option
                                        v-for="(item, index) in refundList.list"
                                        :label="item.val"
                                        :key="index"
                                        :value="item.val"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="联系电话：">
                                <el-input
                                    v-model="form.phone"
                                    :disabled="active == 2 || active == 3"
                                    style="width: 100%;"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="退款说明：">
                                <el-input
                                    type="textarea"
                                    :disabled="active == 2 || active == 3"
                                    v-model="form.content"
                                    style="width: 100%;"
                                ></el-input>
                            </el-form-item>
                        </template>

                        <template v-else>
                            <el-form-item label="服务类型：">
                                <div class="blue">{{ detail.type_text }}</div>
                            </el-form-item>

                            <el-form-item label="退款状态：">
                                <div class="blue">
                                    {{ detail.aftersale_status_text }}
                                </div>
                            </el-form-item>
                            <el-form-item label="退款金额：">
                                <div
                                    class="orange"
                                    v-if="Number(detail.refund_fee)"
                                >
                                    {{ detail.refund_fee }}
                                </div>
                                <div class="red" v-else>未退款</div>
                            </el-form-item>
                            <!-- <div style="font-size: 14px;color: #606266;line-height: 40px;margin-left: 18px;" v-html="detail.logs[detail.logs.length - 1].content">{{detail.logs[detail.logs.length - 1].content}}</div> -->
                        </template>

                        <el-form-item>
                            <el-button
                                type="primary"
                                @click="postAftersale"
                                v-if="
                                    value.btn === 'aftersale' ||
                                        value.btn === 're_aftersale'
                                "
                                >确定</el-button
                            >
                            <block
                                v-for="orderBtn in detail.btns"
                                :key="orderBtn"
                            >
                                <el-button
                                    v-if="orderBtn === 'cancel'"
                                    @click="clearAftersale"
                                    class="cu-btn btn"
                                >
                                    取消
                                </el-button>
                                <el-button
                                    v-if="orderBtn === 'delete'"
                                    @click="onDelete"
                                >
                                    删除
                                </el-button>
                            </block>
                        </el-form-item>
                    </el-form>
                </div>
                <div style="margin-left:200px;margin-top:20px">
                    <el-timeline :reverse="reverse">
                        <el-timeline-item
                            v-for="(activity, index) in activities"
                            :key="index"
                            :timestamp="activity.time"

                        >
                           {{ activity.reason }}
                           <div>
                               {{activity.content}}
                           </div>
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    orderItemDetail,
    aftersaleAdd,
    aftersaleCancel,
    aftersaleDetail,
    aftersaleDelete
} from "@/api/index.js";
import top from "@/components/top.vue";
import breadcrumb from "@/components/breadcrumb.vue";
import bottom from "@/components/bottom.vue";
import { timestampToTime } from "@/util/util.js";
if (localStorage.getItem("userInfo")) {
    var token = JSON.parse(localStorage.getItem("userInfo")).token;
    var header = {
        "Content-Type": "application/json",
        token: token,
        platform: "H5"
    };
}
export default {
    // props: {
    //     value: {
    //         type: Object,
    //         default: {}
    //     }
    // },
    watch: {
        value: {
            handler(newValue) {
                console.log(newValue, "new");
                if (newValue.btn == "aftersale_info") {
                    this.active = 2;
                    this.getAftersaleDetail();
                }
            },
            immediate: true,
            deep: true
        }
    },
    data() {
        return {
            active: 1,
            detail: { aftersale_status: 1 },
            orderDetail: {},
            value: {},
            form: {
                content: "",
                phone: "",
                reason: "",
                type: "refund"
            },
            refundTypeList: [
                {
                    title: "退款",
                    value: "refund"
                },
                {
                    title: "退货",
                    value: "return"
                },
                {
                    title: "其他",
                    value: "other"
                }
            ],
            refundList: {
                title: "申请原因",
                list: [
                    {
                        id: 1,
                        val: "卖家发错货了"
                    },
                    {
                        id: 2,
                        val: "退运费"
                    },
                    {
                        id: 3,
                        val: "大小/重量于商品描述不符"
                    },
                    {
                        id: 4,
                        val: "生产日期、保质期与商品不符"
                    },
                    {
                        id: 5,
                        val: "质量问题"
                    }
                ]
            },
            reverse: false,
            activities: [

            ]
        };
    },
    created() {
        this.value = JSON.parse(this.$route.query.value);
        console.log(this.value);
        this.getOrderItemDetail();
        // console.log(Object.keys(this.value));

        // if (Object.keys(this.value).length > 0) {
        //     this.flag = true;
        //     this.flags = false;
        //     return;
        // }
        // this.flag = false;
    },
    methods: {
        //商品信息
        getOrderItemDetail() {
            let that = this;
            // if (Object.keys(this.value) == 0) {
            //     return;
            // }
            console.log(this.value);
            orderItemDetail(
                {
                    id: this.value.orderId,
                    order_item_id: this.value.orderItemId
                },
                header
            ).then(res => {
                if (res.code === 1) {
                    that.orderDetail = res.data;
                }
            });
        },
        getAftersaleDetail() {
            let that = this;
            aftersaleDetail({ id: this.value.aftersaleId }, header).then(
                res => {
                    if (res.code === 1) {
                        that.detail = res.data;
                        that.form.type = res.data.type;
                        if (
                            res.data.aftersale_status == -1 ||
                            res.data.aftersale_status == 2
                        ) {
                            that.active = 3;
                        }
                        that.detail.logs.forEach(i=>{

                            i.time = timestampToTime(i.createtime * 1000)
                        })
                        console.log(that.detail.logs);
                        this.activities = that.detail.logs
                    } else {
                        this.$message.error(res.msg);
                    }
                }
            );
        },

        postAftersale() {
            //提交申请
            let that = this;
            aftersaleAdd(
                {
                    ...that.form,
                    order_id: this.value.orderId,
                    order_item_id: this.value.orderItemId
                },
                header
            ).then(res => {
                if (res.code !== 1) {
                    return this.$message.error(res.msg);
                }
                this.active = 2;
                this.value.btn = "aftersale_info";
                this.$message.success(res.msg);
                this.$router.push({ path: "/mine" });
            });
        },
        // 取消申请
        clearAftersale() {
            aftersaleCancel({ id: this.value.aftersaleId }, header).then(
                res => {
                    if (res.code == 1) {
                        this.$message("取消成功");
                        this.$router.push({ path: "/mine" });
                    }
                }
            );
        },
        onDelete(aftersaleId) {
            let that = this;
            aftersaleDelete({ id: this.value.aftersaleId }, header).then(
                res => {
                    if (res.code == 1) {
                        this.$message("删除成功");
                        this.$router.push({ path: "/mine" });
                    }
                }
            );
        }
    },
    components: {
        top,
        bottom,
        breadcrumb
    }
};
</script>
<style lang="less">
.step {
    width: 70%;
    margin: 20px 0;
    margin-left: -50px;
}
.refu_wp {
    background-color: #fff;
    padding: 30px;
    margin-top: 20px;
    height: 1000px;
}
.el-timeline-item__wrapper{
    top:0px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/index/mine/refu.vue